import React from "react";
import { HiArrowPath, HiEye, HiUser, HiPencil } from "react-icons/hi2";

const displayMapping = {
  Initial: "Initial",
  Ready: "Ready",
  Review: "Review",
  Published: "Published",
  Retired: "Retired",
  InReview: "InReview",
  ReferBack: "Refer Back",
  ReviewCompleted: "Review Completed",
  ReadyToPublish: "Ready to Publish",
  ProofReading: "Proofreading",
  DataEntryVerification: "Data Entry Verification"
};
const getFriendlyStatus = (status) => displayMapping[status] || status;

const getStatusClass = (status, statusOptions = []) => {
  const statusObj = statusOptions.find(
    (option) =>
      option.label &&
      String(option.label).toLowerCase() === String(status || "").toLowerCase(),
  );

  if (!statusObj) return "";

  const statusValue = String(statusObj.label || "").toLowerCase();
  return `paper-status--${statusValue.replace(/\s+/g, "-")}`;
};

const normalizeWorkflowStatus = (status) =>
  String(status || "").trim().toLowerCase().replace(/\s+/g, "");

const hasFollowUpReview = (reviewState) => {
  const reviews = Array.isArray(reviewState) ? reviewState : reviewState ? [reviewState] : [];
  return reviews.some((review) => review?.is_follow_up === true);
};

const getWorkflowStatusDetails = (status, reviewState, operation_state) => {
  const normalizedStatus = normalizeWorkflowStatus(status);

  if (["review"].includes(normalizedStatus)) {
    if (hasFollowUpReview(reviewState)) {
      return {
        label: "Follow up",
        className: "paper-status--progress",
      };
    }
    return {
      label: "Initial",
      className: "paper-status--progress",
    };
  }

  if (["proofreading"].includes(normalizedStatus)) {
    if (operation_state?.operation_completed === true) {
      return {
        label: "Completed",
        className: "paper-status--proof",
      };
    }
    return {
      label: "In Progress",
      className: "paper-status--proof",
    };
  }

  return null;
};

export function PaperReviewAssignmentCluster({
  item,
  employeeType,
  metaDataOptions,
  onAssign,
  onView,
  onResetAssign,
  onUpdateStatus,
}) {
  const isMasad = employeeType === "MASAD";

  // Status block
  const statusHtml = (
    <div className="paper-review-status-group paper-review-status-group--tight">
      <span className="paper-review-row__assigned-label">Status</span>
      <span
        className={`paper-review-status paper-review-status--pill paper-review-status--compact ${getStatusClass(
          item.status,
          metaDataOptions.statusOptions,
        )}`}
      >
        {getFriendlyStatus(item.status)}
      </span>
    </div>
  );

  // Workflow block
  const workflowDetails = getWorkflowStatusDetails(
    item.status,
    item.review_state,
    item.operation_state_latest
  );
  const showWorkflow = Boolean(workflowDetails);
  const workflowHtml = showWorkflow ? (
    <div className="paper-review-status-group paper-review-status-group--tight">
      <span className="paper-review-row__assigned-label">Workflow</span>
      <span
        className={`paper-review-status paper-review-status--pill paper-review-status--compact ${workflowDetails.className}`}
      >
        {workflowDetails.label}
      </span>
    </div>
  ) : (
    // isMasad && 
    <div className="paper-review-status-placeholder" />
  );

  let clusterClassName = "paper-review-assignment-cluster";
  if (employeeType === "TEACH") {
    clusterClassName += " paper-review-assignment-cluster--teach";
  } else if (employeeType === "DEOP") {
    clusterClassName += " paper-review-assignment-cluster--deop";
  }

  return (
    <div className={clusterClassName}>
      {/* isMasad && (
        <div className="paper-review-assignee-block">
          <span className="paper-review-row__assigned-label">Created by</span>
          <strong className="paper-review-row__assigned" title={item.createByName || ""}>
            {item.createByName || "N/A"}
          </strong>
        </div>
      ) */}

      {statusHtml}
      {workflowHtml}

      <div className="paper-review-assignee-block">
        <span className="paper-review-row__assigned-label">Assigned to</span>
        <strong className="paper-review-row__assigned" title={item.assignedTo || ""}>
          {item.assignedTo || "N/A"}
        </strong>
      </div>

      <div className="paper-review-action-group paper-review-action-group--compact">
        {isMasad && typeof onAssign === "function" && (
          <button
            type="button"
            className="paper-review-icon paper-review-icon--assign"
            onClick={(e) => {
              e.stopPropagation();
              onAssign(item);
            }}
            aria-label={`Assign ${item.name}`}
            title="Assign"
          >
            <HiUser aria-hidden="true" />
          </button>
        )}

        <button
          type="button"
          className="paper-review-icon paper-review-icon--view"
          onClick={() => onView(item)}
          aria-label={`View ${item.name}`}
          title="View"
        >
          <HiEye aria-hidden="true" />
        </button>

        {isMasad && typeof onUpdateStatus === "function" && (
          <button
            type="button"
            className="paper-review-icon paper-review-icon--edit"
            onClick={(e) => {
              e.stopPropagation();
              onUpdateStatus(item);
            }}
            aria-label={`Edit status for ${item.name}`}
            title="Edit Status"
          >
            <HiPencil aria-hidden="true" />
          </button>
        )}

        {/* {isMasad &&
          item.assignedTo &&
          item.status !== "Ready" &&
          typeof onResetAssign === "function" && (
            <button
              type="button"
              className="paper-review-icon paper-review-icon--reset"
              onClick={(e) => {
                e.stopPropagation();
              onResetAssign(item);
            }}
            aria-label={`Reset Assignment for ${item.name}`}
            title="Reset Assign"
          >
            <HiArrowPath aria-hidden="true" />
          </button>
        )} */}
      </div>
    </div>
  );
}

export default function PaperReviewList({
  employeeType,
  items,
  onView,
  onAssign,
  onResetAssign,
  onResetReview,
  onUpdateStatus,
  metaDataOptions = {},
}) {
  console.log("PaperReviewList items:", items);
  if (!items.length) {
    return <div className="paper-review-empty">No papers found.</div>;
  }

  return (
    <div className="paper-review-list">
      {employeeType === "MASAD" &&
        items.map((item) => (
          <article className="paper-review-row" key={item.id}>
            <div className="row g-2 align-items-center">
              <div className="col-12 col-md-2 paper-review-row__code-col">
                <span className="paper-review-row__code">{item.code}</span>
              </div>
              <div className="col-12 col-md-4 paper-review-row__title-col">
                <h3>{item.name}</h3>
              </div>
              <div className="col-12 col-md-6 paper-review-row__cluster-col">
                <PaperReviewAssignmentCluster
                  item={item}
                  employeeType={employeeType}
                  metaDataOptions={metaDataOptions}
                  onAssign={onAssign}
                  onView={onView}
                  onResetAssign={onResetAssign}
                  onUpdateStatus={onUpdateStatus}
                />
              </div>
            </div>
          </article>
        ))}

      {employeeType !== "MASAD" &&
        items.map((item) => (
          <article className="paper-review-row" key={item.id}>
            <div className="row g-2 align-items-center">
              <div className="col-12 col-md-2 paper-review-row__code-col">
                <span className="paper-review-row__code">{item.code}</span>
              </div>
              <div className="col-12 col-md-4 paper-review-row__title-col">
                <h3>{item.name}</h3>
              </div>
              <div className="col-12 col-md-6 paper-review-row__cluster-col">
                <PaperReviewAssignmentCluster
                  item={item}
                  employeeType={employeeType}
                  metaDataOptions={metaDataOptions}
                  onAssign={onAssign}
                  onView={onView}
                  onResetAssign={onResetAssign}
                  onUpdateStatus={onUpdateStatus}
                />
              </div>
            </div>
          </article>
        ))}
    </div>
  );
}
